function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { _translate, WeverCoreContext, _Notifications } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Collector from "../../../../services/collector";
import Responses from "./responses";
import AddStop from "./add_stop";
import Transport from "./transport";

/**
 * @todo Séparer en plusieurs composant fonctionnel.
 */
var SelectionJourney = function SelectionJourney(props) {
  var _currentQuestion$publ, _currentQuestion$publ2, _currentQuestion$publ3, _currentQuestion$publ4, _currentQuestion$publ5;
  var onChange = props.onChange,
    index = props.index;
  var _useState = useState([{}, {}]),
    _useState2 = _slicedToArray(_useState, 2),
    linkedStop = _useState2[0],
    setLinkedStop = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    categorizedExpectedResponse = _useState4[0],
    setCategorizedExpectedResponse = _useState4[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var points_types = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.points_types;
  points_types = points_types ? JSON.parse(points_types) : null;
  var categories = (_currentQuestion$publ2 = currentQuestion.publicParameters) === null || _currentQuestion$publ2 === void 0 ? void 0 : _currentQuestion$publ2.mode_categories_to_display_lines;
  var excluded_modes = (_currentQuestion$publ3 = currentQuestion.publicParameters) === null || _currentQuestion$publ3 === void 0 ? void 0 : _currentQuestion$publ3.excluded_modes;
  var excluded_modes_center = (_currentQuestion$publ4 = currentQuestion.publicParameters) === null || _currentQuestion$publ4 === void 0 ? void 0 : _currentQuestion$publ4.excluded_modes_center;
  var points_filters = (_currentQuestion$publ5 = currentQuestion.publicParameters) === null || _currentQuestion$publ5 === void 0 ? void 0 : _currentQuestion$publ5.points_filter_with_lines;
  excluded_modes = excluded_modes ? JSON.parse(excluded_modes) : null;
  excluded_modes_center = excluded_modes_center ? JSON.parse(excluded_modes_center) : null;
  points_filters = points_filters ? JSON.parse(points_filters) : null;
  categories = categories ? JSON.parse(categories) : null;
  var categoriesExists = categories && Array.isArray(categories) && categories.length > 0;
  var getPointsFilters = function getPointsFilters(lines, mode) {
    var filters = {};
    if (mode) {
      filters['mode'] = mode;
    }
    if (points_types) {
      points_types.forEach(function (type, index) {
        filters["types[".concat(index, "]")] = type;
      });
    }
    var pointsFiltersLine = lines || points_filters;
    if (!pointsFiltersLine) {
      return filters;
    }
    filters['no_limit'] = true;
    pointsFiltersLine.forEach(function (line, index) {
      filters["lines[".concat(index, "]")] = line;
    });
    return filters;
  };

  /**
   * Vérifie si une des expectedResponse rentre dans une des catégories
   */
  var _hasCategories = function hasCategories(responseCategories) {
    var length = responseCategories.length;
    for (var i = 0; i < length; i++) {
      if (categories.includes(responseCategories[i].id)) {
        return true;
      }
      if (categories.parent) {
        return _hasCategories([categories.parent]);
      }
    }
    return false;
  };

  // en mémoire
  var getExpectedReponsesInCategories = function getExpectedReponsesInCategories() {
    if (!categoriesExists) {
      return currentQuestion.expectedResponses;
    }
    var tmpCategorized = [];
    currentQuestion.expectedResponses.forEach(function (expectedResponse) {
      if (!expectedResponse.categories || expectedResponse.categories.length === 0) {
        return null;
      }
      if (_hasCategories(expectedResponse.categories)) {
        tmpCategorized.push(expectedResponse.alias);
      }
    });
    setCategorizedExpectedResponse(tmpCategorized);
  };

  /**
   * A chaque changement, nous formattons les lieux/modes choisit
   * Pour les mettre dans le contexte au bon endroit.
   */
  var handleResponsesFormatAndUpload = function handleResponsesFormatAndUpload(stops) {
    var stopsResponses = {};
    var passNumber = 0;
    // On reconstruit les réponses.
    stops.forEach(function (stop, indexStop) {
      var _stop$line, _stop$line2, _stop$line3, _stop$line4;
      var endStop = indexStop > 0 ? stop.arrival : stops[indexStop + 1];
      if (!endStop) {
        return;
      }
      if (_typeof(endStop) === 'object') {
        endStop.id = endStop.id || endStop._id || null;
        var endStopName = endStop === null || endStop === void 0 ? void 0 : endStop.name;
        if (endStopName) {
          endStop.name = _typeof(endStop === null || endStop === void 0 ? void 0 : endStop.name) === 'object' ? endStop.name[locale] : endStop.name;
        }
      }
      if (!stop.mode && indexStop > 0) {
        return;
      }
      stopsResponses["start_id_j".concat(indexStop)] = stop.id || 'NA';
      stopsResponses["start_name_j".concat(indexStop)] = stop.name || 'NA';
      stopsResponses["start_alias_j".concat(indexStop)] = stop.alias || 'NA';
      stopsResponses["end_id_j".concat(indexStop)] = endStop.id || 'NA';
      stopsResponses["end_name_j".concat(indexStop)] = endStop.name || 'NA';
      stopsResponses["end_alias_j".concat(indexStop)] = endStop.alias || 'NA';
      stopsResponses["mode_j".concat(indexStop)] = stop.mode;
      stopsResponses["line_j".concat(indexStop)] = ((_stop$line = stop.line) === null || _stop$line === void 0 ? void 0 : _stop$line.id) || ((_stop$line2 = stop.line) === null || _stop$line2 === void 0 ? void 0 : _stop$line2._id) || (stop.line === 'NA' ? stop.line : null);
      stopsResponses["line_alias_j".concat(indexStop)] = (_stop$line3 = stop.line) === null || _stop$line3 === void 0 ? void 0 : _stop$line3.alias;
      stopsResponses["line_name_j".concat(indexStop)] = (_stop$line4 = stop.line) === null || _stop$line4 === void 0 ? void 0 : _stop$line4.name;
      passNumber++;
      var lastIndex = indexStop + 1;
      var end = stops[lastIndex];
      if (end && lastIndex === stops.length - 1 && stops.length > 2) {
        stopsResponses["start_id_j".concat(lastIndex)] = endStop.id || 'NA';
        stopsResponses["start_name_j".concat(lastIndex)] = endStop.name || 'NA';
        stopsResponses["start_alias_j".concat(lastIndex)] = endStop.alias || 'NA';
        stopsResponses["end_id_j".concat(lastIndex)] = end.id;
        stopsResponses["end_name_j".concat(lastIndex)] = end.name;
        stopsResponses["end_alias_j".concat(lastIndex)] = end.alias;
        stopsResponses["mode_j".concat(lastIndex)] = stop.end_mode;
        passNumber++;
      }
    });
    var additionLength = stops.length > 2 ? 0 : -1;
    onChange({}, passNumber === stops.length + additionLength ? stopsResponses : {}, null, index);
  };

  /**
   * Gère le changement sur l'autocomplete
   */
  var handleChange = function handleChange(optionsToValue, options, indexChange) {
    var cloned = _toConsumableArray(linkedStop);
    var optionValue = options.value;
    var _ref = optionValue || {},
      name = _ref.name;
    cloned[indexChange].name = name ? name[locale] : null;
    cloned[indexChange].id = optionValue.id || optionValue._id || null;
    cloned[indexChange].alias = optionValue !== 'NA' ? optionValue.alias : 'NA';
    delete cloned[indexChange].line;
    delete cloned[indexChange].arrival;
    setLinkedStop(cloned);
    handleResponsesFormatAndUpload(cloned);
  };
  var handleAutocompleteChange = function handleAutocompleteChange(name, optionToValue, options, indexChange) {
    var cloned = _toConsumableArray(linkedStop);
    cloned[indexChange][name] = options.value;
    if (name === 'line') {
      delete cloned[indexChange]['arrival'];
    }
    setLinkedStop(cloned);
    handleResponsesFormatAndUpload(cloned);
  };
  var deleteTransport = function deleteTransport(index) {
    var cloned = _toConsumableArray(linkedStop);
    cloned.splice(index, 1);
    setLinkedStop(cloned);
    handleResponsesFormatAndUpload(cloned);
  };

  /**
   * Ajoute un intermédiaire
   */
  var addTransport = function addTransport(afterInt) {
    var cloned = _toConsumableArray(linkedStop);
    var endMode = cloned[afterInt].endMode;
    cloned.splice(afterInt + 1, 0, {
      endMode: endMode
    });
    if (endMode) {
      cloned[afterInt].endMode = null;
    }
    setLinkedStop(cloned);
    handleResponsesFormatAndUpload(cloned);
  };

  /**
   * Lorsque le mode change
   */
  var handleModeChange = function handleModeChange(name, mode, indexRow) {
    var cloned = _toConsumableArray(linkedStop);
    cloned[indexRow][name] = mode;
    if (name !== 'end_mode' && indexRow > 0) {
      delete cloned[indexRow]['id'];
      delete cloned[indexRow]['alias'];
      delete cloned[indexRow]['name'];
      delete cloned[indexRow]['line'];
      delete cloned[indexRow]['arrival'];
    }
    setLinkedStop(cloned);
    handleResponsesFormatAndUpload(cloned);
  };
  var getNameFromParams = function getNameFromParams(element) {
    var name = null;
    var coordinates = null;
    var alias = null;
    if (element.responses["".concat(element.questionAlias, "_complete")] || element.responses["".concat(element.questionAlias, "_address")]) {
      name = element.responses["".concat(element.questionAlias, "_complete")] || element.responses["".concat(element.questionAlias, "_address")];
      coordinates = element.responses["".concat(element.questionAlias, "_coordinate")];
      alias = element.questionAlias;
    } else {
      var _element$questionObj;
      // prendre nom dans les réponses.
      alias = Object.keys(element.responses)[0];
      if ((_element$questionObj = element.questionObj) !== null && _element$questionObj !== void 0 && _element$questionObj.expectedResponses) {
        element.questionObj.expectedResponses.map(function (r) {
          if (r.alias === alias) {
            name = r.name[locale];
          }
        });
      }
    }
    return [name, coordinates, alias];
  };
  var initialization = function initialization() {
    // Get the values inside the context
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var currentResponses = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
    var questionParameters = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.publicParameters;
    var departureParameters = questionParameters !== null && questionParameters !== void 0 && questionParameters.departure ? JSON.parse(questionParameters === null || questionParameters === void 0 ? void 0 : questionParameters.departure) : {};
    var arrivalParameters = questionParameters !== null && questionParameters !== void 0 && questionParameters.arrival ? JSON.parse(questionParameters === null || questionParameters === void 0 ? void 0 : questionParameters.arrival) : {};
    var departure = Collector.getQuestionByAlias(responses, departureParameters.questionAlias, currentOrder);
    var arrival = Collector.getQuestionByAlias(responses, arrivalParameters.questionAlias, currentOrder);
    getExpectedReponsesInCategories();
    if (!departure || !arrival) {
      _Notifications.error(_translate('error'), _translate('journey_miss_info_on_departure_or_arrival'));
      return;
    }
    var linkedStopStarters = _toConsumableArray(linkedStop);
    var _getNameFromParams = getNameFromParams(departure),
      _getNameFromParams2 = _slicedToArray(_getNameFromParams, 3),
      departureName = _getNameFromParams2[0],
      departureCoordinates = _getNameFromParams2[1],
      departureAlias = _getNameFromParams2[2];
    var _getNameFromParams3 = getNameFromParams(arrival),
      _getNameFromParams4 = _slicedToArray(_getNameFromParams3, 3),
      arrivalName = _getNameFromParams4[0],
      arrivalCoordinates = _getNameFromParams4[1],
      arrivalAlias = _getNameFromParams4[2];
    linkedStopStarters[0] = {
      name: departureName,
      coordinates: departureCoordinates,
      id: departure.questionId,
      alias: departureAlias
    };
    linkedStopStarters[1] = {
      name: arrivalName,
      coordinates: arrivalCoordinates,
      id: arrival.questionId,
      alias: arrivalAlias
    };
    if (!currentResponses) {
      var endMode = linkedStopStarters[0].endMode;
      linkedStopStarters.splice(1, 0, {
        endMode: endMode
      });
      if (linkedStopStarters) {
        linkedStopStarters[0].endMode = null;
      }
      setLinkedStop(linkedStopStarters);
      handleResponsesFormatAndUpload(linkedStopStarters);
      return;
    }
    try {
      // On recréé le tableau propre à ce type.
      // Sinon on verra pas nos résultats si l'utilisateur est connecté
      // ou retourne en arrière sur la page
      var questionAlias = currentQuestion.alias;
      var keysCurrentResponses = Object.keys(currentResponses);
      keysCurrentResponses.forEach(function (alias, index) {
        var aliasFormated = alias.replace("".concat(questionAlias, "_"), '');
        // On connait à l'avance toutes les positions.
        var explodedAlias = aliasFormated.split('_');
        var position = explodedAlias[0];
        var type = explodedAlias[1];
        var jIndex = explodedAlias[2];
        if (explodedAlias.length < 3) {
          position = 'mode';
          type = explodedAlias[0];
          jIndex = explodedAlias[1];
        }
        var fieldAlias = currentResponses["".concat(questionAlias, "_").concat(position, "_alias_").concat(explodedAlias[2])];

        /* // On récupère le bon index
        if (position === 'start' || position === 'end' || (position === 'line' && jIndex)) {
          jIndex = parseInt(jIndex.replace('j', ''), 10);
           // if (position === 'end') {
          //   jIndex++;
          // }
        } else {
          jIndex = parseInt(type.replace('j', ''), 10);
          type = position;
        } */
        jIndex = parseInt(jIndex.replace('j', ''), 10);
        if (jIndex > 0 && index + 1 === keysCurrentResponses.length && type === 'mode') {
          //linkedStopStarters[jIndex - 1 < 0 ? 0 : jIndex - 1][`${position == "end" ? "end_" : ""}mode`] = currentResponses[alias];

          linkedStopStarters[jIndex - 1]['end_mode'] = currentResponses[alias];
          return;
        }

        // on recréé
        if (jIndex && !linkedStopStarters[jIndex]) {
          linkedStopStarters[jIndex] = {
            arrival: {},
            line: {}
          };
        }
        if (!linkedStopStarters[jIndex]['arrival']) linkedStopStarters[jIndex]['arrival'] = {};
        switch (position) {
          case 'start':
          case 'mode':
            // --- VALEUR NORMALE
            if (currentResponses[alias] !== 'NA') {
              linkedStopStarters[jIndex][type] = currentResponses[alias];
            } else {
              linkedStopStarters[jIndex]['alias'] = 'NA';
            }

            // REMISE DE L'ALIAS
            if (position === 'start') {
              if (fieldAlias !== 'NA') {
                linkedStopStarters[jIndex]['alias'] = fieldAlias;
              } else {
                linkedStopStarters[jIndex]['alias'] = 'NA';
                linkedStopStarters[jIndex]['id'] = null;
                linkedStopStarters[jIndex]['name'] = null;
              }
            }
            break;
          case 'line':
            // Je ne sais pas ou sais-je ?
            if (currentResponses[alias] && currentResponses[alias] !== 'NA') {
              if (_typeof(linkedStopStarters[jIndex]['line']) != 'object') linkedStopStarters[jIndex]['line'] = {};
              var jKey = type === position ? 'id' : type;
              var jVal = currentResponses[alias];
              linkedStopStarters[jIndex]['line'] = _defineProperty({}, jKey, jVal);

              //linkedStopStarters[jIndex]['line'][type === position ? 'id' : type] = currentResponses[alias];
            } else {
              linkedStopStarters[jIndex]['line'] = 'NA';
            }
            break;
          case 'end':
            if (currentResponses[alias] !== 'NA' && _typeof(linkedStopStarters[jIndex]['arrival']) === 'object') {
              linkedStopStarters[jIndex]['arrival'][type] = currentResponses[alias];
            } else {
              linkedStopStarters[jIndex]['arrival'] = 'NA';
            }
            break;
          default:
        }
      });
      setLinkedStop(linkedStopStarters);
    } catch (e) {
      console.error({
        e: e
      });
    }
  };

  /**
   * Initialization
   */
  useEffect(function () {
    initialization();
  }, []);
  var dashedLine = function dashedLine(className) {
    return /*#__PURE__*/React.createElement("div", {
      className: "stop-line d-flex justify-content-center ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner"
    }));
  };
  var getRow = function getRow(stop, i, max) {
    var _stop$arrival, _stop$line5, _stop$line6;
    var stops = [];
    var Line = null;
    if (i + 1 < max) {
      Line = dashedLine('pr-3 h-100');
    }
    var isNotBetween = i === 0 || i + 1 === max;
    stops.push( /*#__PURE__*/React.createElement(Transport, {
      stop: stop,
      isBetween: !isNotBetween,
      handleModeChange: handleModeChange,
      handleChange: handleChange,
      handleAutocompleteChange: handleAutocompleteChange,
      getPointsFilters: getPointsFilters,
      deleteTransport: deleteTransport,
      index: i,
      name: i == linkedStop.length - 1 ? (_stop$arrival = stop.arrival) !== null && _stop$arrival !== void 0 && _stop$arrival.name ? stop.arrival.name : stop.name : stop.name,
      categorizedExpectedResponse: categorizedExpectedResponse,
      hasResponse: i + 1 !== max
    }));
    var lineId = ((_stop$line5 = stop.line) === null || _stop$line5 === void 0 ? void 0 : _stop$line5.id) || ((_stop$line6 = stop.line) === null || _stop$line6 === void 0 ? void 0 : _stop$line6._id);
    if (i + 1 < max) {
      stops.push( /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        className: "col-1 px-0 d-flex align-items-center justify-content-end "
      }, Line), /*#__PURE__*/React.createElement(Col, {
        className: "col-11 "
      }, /*#__PURE__*/React.createElement(Row, {
        className: "w-90 mx-auto p-0 d-flex justify-content-center"
      }, i > 0 && isNotBetween ? /*#__PURE__*/React.createElement("div", {
        className: "dashedLineBetween w-100"
      }, dashedLine('')) : null), /*#__PURE__*/React.createElement(AddStop, {
        addTransport: addTransport,
        index: i
      }), max > 2 && i + 2 === max && /*#__PURE__*/React.createElement(Row, {
        className: "p-0 mb-1"
      }, /*#__PURE__*/React.createElement(Col, {
        sm: "12",
        className: "text-center d-flex justify-content-center flex-column "
      }, /*#__PURE__*/React.createElement(Row, {
        className: "d-flex justify-content-center w-90 mb-2"
      }, /*#__PURE__*/React.createElement(Responses, {
        responses: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.expectedResponses,
        excluded: excluded_modes,
        mode: stop.end_mode,
        locale: locale,
        indexRow: i,
        onChange: function onChange() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return handleModeChange.apply(void 0, ['end_mode'].concat(args));
        }
      })), dashedLine('after-response'))))));
    }
    return stops;
  };
  return linkedStop.map(function (stop, i) {
    return getRow(stop, i, linkedStop.length);
  });
};
SelectionJourney.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
SelectionJourney.defaultProps = {
  elements: [],
  responses: {}
};
export default SelectionJourney;